import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { SectiuniProiecteService } from '../sectiuni-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ISectiuneAddPayload, ISectiuneForm } from '../sectiuni-proiecte.interface';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-add-sectiuni-proiecte',
    templateUrl: './add-sectiuni-proiecte.component.html',
    styleUrls: ['./add-sectiuni-proiecte.component.scss']
})
export class AddSectiuniProiecteComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddSectiuniProiecteComponent>,
        private sectiuniProiecteService: SectiuniProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name } = this.form.value as ISectiuneForm;
        const payload: ISectiuneAddPayload = {
            name,
        };

        this.sectiuniProiecteService
            .addSectiune(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
